import { AppGlobalService } from '@app/app-global.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { VsMenuService } from '@app/widget/vs-menu/vs-menu.service';
import { AuthenticationService } from '@app/auth/authentication.service';
import { Router, Event, NavigationStart, NavigationEnd, NavigationError, ActivatedRoute } from '@angular/router';
import { UtilService } from '@app/core/util.service';

import { NotificationService } from '@app/shared/services/notification.service';
import { CustomService } from '@custom/services/custom.service';
import { VsTabmenuIntegrationService } from '@app/widget/vs-tabmenu-integration.service';
import { Title } from '@angular/platform-browser';
import { NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
export class HomeComponentHandler {
    sideMenuconfig = [];
    NgbDropdownMenu: any;
    dropdownEnabled: boolean = true;

    constructor(
        public menuService: VsMenuService,
        public translate: TranslateService,
        public auth: AuthenticationService,
        public route: ActivatedRoute,
        public router: Router,
        public appGlobalService: AppGlobalService,
        public utilService: UtilService,         
        public notification: NotificationService,
        public customService: CustomService,
        public tmIntegration: VsTabmenuIntegrationService,
        public titleService: Title
    ) { }

    public logoutAction() {
        window.location.href = window.location.origin + '/saml/logout';
    }

    public extendLogoutConfig(data) {
        data.action = () => {
            this.logoutAction();
        }
        return data;
    }
    getUserFirstName() {
        if(this.appGlobalService.get('prototyping')) {
            return "Admin";
        }
        if(this.auth.getcurrentUser().admin){
            this.dropdownEnabled= true;
        }else if(this.auth.getcurrentUser().corporate){
            this.dropdownEnabled= true;
        }else if(this.auth.getcurrentUser().coExOwner){
            this.dropdownEnabled= true;
        }else if(this.auth.getcurrentUser().inExOwner){
            this.dropdownEnabled= true;
        }else if(this.auth.getcurrentUser().userRoles.length == 0){
            this.dropdownEnabled= false;
        }else if(this.auth.getcurrentUser().owner){
            this.dropdownEnabled= true;
        }
        return this.auth.getcurrentUser()?.firstName;
    }

    public extendUserData(data) {
        if(data.admin){
            this.sideMenuconfig = [
                {
                    "label": 'Application Users',
                    "icon": 'fa fa-users',
                    "path": 'home/appuserprivileges/appuserprivilegeslist',
                    "type": 'users',
                    "roles": ["admin"]
                },
                {
                    "label": 'Company',
                    "icon": 'fa fa-building',
                    "path": 'home/solvaycompany/solvaycompanylist',
                    "type": 'solvay_company',
                    "roles": ["admin"]
                },
                {
                    "label": 'Site',
                    "icon": 'fa fa-sitemap',
                    "path": 'home/solvaysite/solvaysitelist',
                    "type": 'solvay_site',
                    "roles": ["admin"]
                },
                {
                    "label": 'User Information',
                    "icon": 'fa fa-user',
                    "path": 'home/userinformation/userinformationlist',
                    "type": 'user_information',
                    "roles": ["admin"]
                },
                {
                    "label": 'User Whitelist',
                    "icon": ' fa fa-user-plus',
                    "path": 'home/userwhitelist/userwhitelistlist',
                    "type": 'user_whitelist',
                    "roles": ["admin"]
                },
                {
                    "label": 'User Blacklist',
                    "icon": 'fa fa-user-times',
                    "path": 'home/userblacklist/userblacklistlist',
                    "type": 'user_blacklist',
                    "roles": ["admin"]
                },
                {
                    "label": 'Company Licence Authorization',
                    "icon": 'fa fa-at',
                    "path": 'home/companyauthorization/companyauthorizationlist',
                    "type": 'company_authorization',
                    "roles": ["admin"]
                },
                {
                    "label": 'Control Group Country',
                    "icon": 'fa fa-flag',
                    "path": 'home/controlgroupcountry/controlgroupcountrylist',
                    "type": 'control_groupcountry',
                    "roles": ["admin"]
                },
                {
                    "label": 'Control Group',
                    "icon": 'fa fa-object-group',
                    "path": 'home/controlgroup/controlgrouplist',
                    "type": 'control_group',
                    "roles": ["admin"]
                },
                {
                    "label": 'Change Log',
                    "icon": 'fa fa-file-text',
                    "path": 'home/changelog/changeloglist',
                    "type": 'change_log',
                    "roles": ["admin"]
                },
                {
                    "label": 'SFT & AFT Job Tracking Dashboard',
                    "icon": 'fa fa-table',
                    "type": 'sftp_dashboard',
                    "path": 'home/sftptrackerdashboards/sftpdashboard-detail',
                    "roles": ["admin"]
                },
                {
                    "label": 'Daily Sync Job Tracking Dashboard',
                    "icon": 'fa fa-dashboard',
                    "path": 'home/dailysynctrackerdashboard/dailysyncdashboard-detail',
                    "type": 'daily_sync_dashboard',
                    "roles": ["admin"]
                },
                {
                    "label": 'SAP Details Dashboard',
                    "icon": 'fa fa-cogs',
                    "path": 'home/sapdetailsdashboard/sapdetailsdashboard-detail',
                    "type": 'sap_details_dashboard',
                    "roles": ["admin"]
                }
            ]
        return data;
        }
        else if(data.supportTeam){
            this.sideMenuconfig = [
                {
                    "label": 'SFTP Tracker Dashboard',
                    "icon": 'fa fa-table',
                    "type": 'sftp_dashboard',
                    "path": 'home/sftptrackerdashboards/sftpdashboard-detail',
                    "roles": ["supportTeam"]
                },
                {
                    "label": 'Daily Sync Tracker Dashboard',
                    "icon": 'fa fa-dashboard',
                    "path": 'home/dailysynctrackerdashboard/dailysyncdashboard-detail',
                    "type": 'daily_sync_dashboard',
                    "roles": ["supportTeam"]
                },
                {
                    "label": 'SAP Details Dashboard',
                    "icon": 'fa fa-cogs',
                    "path": 'home/sapdetailsdashboard/sapdetailsdashboard-detail',
                    "type": 'sap_details_dashboard',
                    "roles": ["supportTeam"]
                }
            ]
            return data;
        }
        else if(data.coExOwner){
            this.sideMenuconfig = [
                {
                    "label": 'User Whitelist',
                    "icon": ' fa fa-user-plus',
                    "path": 'home/userwhitelist/userwhitelistlist',
                    "type": 'user_whitelist',
                    "roles": ["coExOwner"]
                },
                {
                    "label": 'User Blacklist',
                    "icon": 'fa fa-user-times',
                    "path": 'home/userblacklist/userblacklistlist',
                    "type": 'user_blacklist',
                    "roles": ["coExOwner"]
                },
                {
                    "label": 'Company Licence Authorization',
                    "icon": 'fa fa-at',
                    "path": 'home/companyauthorization/companyauthorizationlist',
                    "type": 'company_authorization',
                    "roles": ["coExOwner"]
                },
                {
                    "label": 'Company',
                    "icon": 'fa fa-building',
                    "path": 'home/solvaycompany/solvaycompanylist',
                    "type": 'solvay_company',
                    "roles": ["coExOwner"]
                },
                {
                    "label": 'Site',
                    "icon": 'fa fa-sitemap',
                    "path": 'home/solvaysite/solvaysitelist',
                    "type": 'solvay_site',
                    "roles": ["coExOwner"]
                },
                {
                    "label": 'User Information',
                    "icon": 'fa fa-user',
                    "path": 'home/userinformation/userinformationlist',
                    "type": 'user_information',
                    "roles": ["coExOwner"]
                }
            ]
            return data;
        }else if(data.inExOwner){
            this.sideMenuconfig = [
                {
                    "label": 'User Whitelist',
                    "icon": ' fa fa-user-plus',
                    "path": 'home/userwhitelist/userwhitelistlist',
                    "type": 'user_whitelist',
                    "roles": ["inExOwner"]
                },
                {
                    "label": 'User Blacklist',
                    "icon": 'fa fa-user-times',
                    "path": 'home/userblacklist/userblacklistlist',
                    "type": 'user_blacklist',
                    "roles": ["inExOwner"]
                },
                {
                    "label": 'Company',
                    "icon": 'fa fa-building',
                    "path": 'home/solvaycompany/solvaycompanylist',
                    "type": 'solvay_company',
                    "roles": ["inExOwner"]
                },
                {
                    "label": 'Site',
                    "icon": 'fa fa-sitemap',
                    "path": 'home/solvaysite/solvaysitelist',
                    "type": 'solvay_site',
                    "roles": ["inExOwner"]
                },
                {
                    "label": 'User Information',
                    "icon": 'fa fa-user',
                    "path": 'home/userinformation/userinformationlist',
                    "type": 'user_information',
                    "roles": ["inExOwner"]
                }
            ]
            return data;
        }else if(data.corporate){
            this.sideMenuconfig = [
                {
                    "label": 'Control Group Country',
                    "icon": 'fa fa-flag',
                    "path": 'home/controlgroupcountry/controlgroupcountrylist',
                    "type": 'control_groupcountry',
                    "roles": ["corporate"]
                },
                {
                    "label": 'Control Group',
                    "icon": 'fa fa-object-group',
                    "path": 'home/controlgroup/controlgrouplist',
                    "type": 'control_group',
                    "roles": ["corporate"]
                }
            ]
            return data;
        } else if(data.owner){
            this.sideMenuconfig = [
                {
                    "label": 'User Information',
                    "icon": 'fa fa-user',
                    "path": 'home/userinformation/userinformationlist',
                    "type": 'user_information',
                    "roles": ["owner"]
                },
                {
                    "label": 'Company',
                    "icon": 'fa fa-building',
                    "path": 'home/solvaycompany/solvaycompanylist',
                    "type": 'solvay_company',
                    "roles": ["owner"]
                },
                {
                    "label": 'Site',
                    "icon": 'fa fa-sitemap',
                    "path": 'home/solvaysite/solvaysitelist',
                    "type": 'solvay_site',
                    "roles": ["owner"]
                },
            ]
            return data;
        } 
        else if(this.appGlobalService.get('prototyping')) {
            this.sideMenuconfig = [
                {
                    "label": 'Application Users',
                    "icon": 'fa fa-users',
                    "path": 'home/appuserprivileges/appuserprivilegeslist',
                    "type": 'users',
                    "roles": ["admin"]
                },
                {
                    "label": 'Company',
                    "icon": 'fa fa-building',
                    "path": 'home/solvaycompany/solvaycompanylist',
                    "type": 'solvay_company',
                    "roles": ["admin"]
                },
                {
                    "label": 'Site',
                    "icon": 'fa fa-sitemap',
                    "path": 'home/solvaysite/solvaysitelist',
                    "type": 'solvay_site',
                    "roles": ["admin"]
                },
                {
                    "label": 'User Information',
                    "icon": 'fa fa-user',
                    "path": 'home/userinformation/userinformationlist',
                    "type": 'user_information',
                    "roles": ["admin"]
                },
                {
                    "label": 'User Whitelist',
                    "icon": ' fa fa-user-plus',
                    "path": 'home/userwhitelist/userwhitelistlist',
                    "type": 'user_whitelist',
                    "roles": ["admin"]
                },
                {
                    "label": 'User Blacklist',
                    "icon": 'fa fa-user-times',
                    "path": 'home/userblacklist/userblacklistlist',
                    "type": 'user_blacklist',
                    "roles": ["admin"]
                },
                {
                    "label": 'Company Licence Authorization',
                    "icon": 'fa fa-at',
                    "path": 'home/companyauthorization/companyauthorizationlist',
                    "type": 'company_authorization',
                    "roles": ["admin"]
                },
                {
                    "label": 'Control Group Country',
                    "icon": 'fa fa-flag',
                    "path": 'home/controlgroupcountry/controlgroupcountrylist',
                    "type": 'control_groupcountry',
                    "roles": ["admin"]
                },
                {
                    "label": 'Control Group',
                    "icon": 'fa fa-object-group',
                    "path": 'home/controlgroup/controlgrouplist',
                    "type": 'control_group',
                    "roles": ["admin"]
                },
                {
                    "label": 'Change Log',
                    "icon": 'fa fa-file-text',
                    "path": 'home/changelog/changeloglist',
                    "type": 'change_log',
                    "roles": ["admin"]
                },
                {
                    "label": 'SFTP Tracker Dashboard',
                    "icon": 'fa-table',
                    "path": 'home/sftptrackerdashboard/sftpdashboard',
                    "type": 'sftp_dashboard',
                    "roles": ["admin"]
                }
            ]
        return data;
        }      
    }
    showSideMenuItem(roles: string[]) {
        if(this.appGlobalService.get('prototyping')) {
            return true;
        }
        if(roles) {
            if(roles.includes('admin') && this.auth.getcurrentUser()?.admin) {
                return true;
            } else if(roles.includes('coExOwner') && this.auth.getcurrentUser()?.coExOwner) {
                return true;
            } else if(roles.includes('inExOwner')&& this.auth.getcurrentUser()?.inExOwner) {
                return true;
            } else if(roles.includes('corporate') && this.auth.getcurrentUser()?.corporate) {
                return true;
            }
            else if(roles.includes('owner') && this.auth.getcurrentUser()?.owner) {
                return true;
            }
            else if(roles.includes('supportTeam') && this.auth.getcurrentUser()?.supportTeam) {
                return true;
            }
        }
        return false;
    }    
    clickedMenuItem(path: string, type: string) {
        this.router.navigate([ path ]);
      }

    public handleNotificationEventExt(ev) {
        console.log(ev);
    }

}